import { useRef } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../api';
import { extensoesTiptap, paraExibicao, urlImagem } from './tiptapBase';

function Btn({ ativo, onClick, titulo, children, desabilitado }) {
  return (
    <button
      type="button"
      className={`tt-btn${ativo ? ' tt-btn--ativo' : ''}`}
      onMouseDown={(e) => e.preventDefault()}
      onClick={onClick}
      disabled={desabilitado}
      title={titulo}
    >
      {children}
    </button>
  );
}

export default function TiptapEditor({ valorInicial, onChange }) {
  const { token } = useAuth();
  const fileRef = useRef(null);

  const editor = useEditor({
    extensions: extensoesTiptap,
    content: valorInicial ? paraExibicao(valorInicial, token) : '',
    onUpdate: ({ editor }) => onChange && onChange(editor.getJSON()),
  });

  if (!editor) return null;

  function inserirLink() {
    const anterior = editor.getAttributes('link').href || '';
    const url = window.prompt('Link (URL):', anterior);
    if (url === null) return;
    if (url === '') { editor.chain().focus().extendMarkRange('link').unsetLink().run(); return; }
    editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
  }

  async function enviarImagem(e) {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    try {
      const fd = new FormData();
      fd.append('imagem', file);
      const { data } = await api.post('/documentos/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      editor.chain().focus().setImage({ src: urlImagem(data.url, token) }).run();
    } catch (err) {
      alert(err.response?.data?.error || 'Não foi possível enviar a imagem.');
    }
  }

  return (
    <div className="tt-wrap">
      <div className="tt-toolbar">
        <Btn titulo="Negrito" ativo={editor.isActive('bold')} onClick={() => editor.chain().focus().toggleBold().run()}><i className="bi bi-type-bold"></i></Btn>
        <Btn titulo="Itálico" ativo={editor.isActive('italic')} onClick={() => editor.chain().focus().toggleItalic().run()}><i className="bi bi-type-italic"></i></Btn>
        <Btn titulo="Tachado" ativo={editor.isActive('strike')} onClick={() => editor.chain().focus().toggleStrike().run()}><i className="bi bi-type-strikethrough"></i></Btn>
        <span className="tt-sep" />
        <Btn titulo="Título 1" ativo={editor.isActive('heading', { level: 1 })} onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}><b>H1</b></Btn>
        <Btn titulo="Título 2" ativo={editor.isActive('heading', { level: 2 })} onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}><b>H2</b></Btn>
        <Btn titulo="Título 3" ativo={editor.isActive('heading', { level: 3 })} onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}><b>H3</b></Btn>
        <span className="tt-sep" />
        <Btn titulo="Lista" ativo={editor.isActive('bulletList')} onClick={() => editor.chain().focus().toggleBulletList().run()}><i className="bi bi-list-ul"></i></Btn>
        <Btn titulo="Lista numerada" ativo={editor.isActive('orderedList')} onClick={() => editor.chain().focus().toggleOrderedList().run()}><i className="bi bi-list-ol"></i></Btn>
        <Btn titulo="Citação" ativo={editor.isActive('blockquote')} onClick={() => editor.chain().focus().toggleBlockquote().run()}><i className="bi bi-quote"></i></Btn>
        <span className="tt-sep" />
        <Btn titulo="Link" ativo={editor.isActive('link')} onClick={inserirLink}><i className="bi bi-link-45deg"></i></Btn>
        <Btn titulo="Imagem" onClick={() => fileRef.current?.click()}><i className="bi bi-image"></i></Btn>
        <Btn titulo="Tabela" onClick={() => editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run()}><i className="bi bi-table"></i></Btn>
        <span className="tt-sep" />
        <Btn titulo="Desfazer" desabilitado={!editor.can().undo()} onClick={() => editor.chain().focus().undo().run()}><i className="bi bi-arrow-counterclockwise"></i></Btn>
        <Btn titulo="Refazer" desabilitado={!editor.can().redo()} onClick={() => editor.chain().focus().redo().run()}><i className="bi bi-arrow-clockwise"></i></Btn>
      </div>

      {editor.isActive('table') && (
        <div className="tt-toolbar tt-toolbar--tabela">
          <Btn titulo="Coluna antes" onClick={() => editor.chain().focus().addColumnBefore().run()}>+Col ◀</Btn>
          <Btn titulo="Coluna depois" onClick={() => editor.chain().focus().addColumnAfter().run()}>▶ +Col</Btn>
          <Btn titulo="Remover coluna" onClick={() => editor.chain().focus().deleteColumn().run()}>−Col</Btn>
          <span className="tt-sep" />
          <Btn titulo="Linha antes" onClick={() => editor.chain().focus().addRowBefore().run()}>+Lin ▲</Btn>
          <Btn titulo="Linha depois" onClick={() => editor.chain().focus().addRowAfter().run()}>▼ +Lin</Btn>
          <Btn titulo="Remover linha" onClick={() => editor.chain().focus().deleteRow().run()}>−Lin</Btn>
          <span className="tt-sep" />
          <Btn titulo="Excluir tabela" onClick={() => editor.chain().focus().deleteTable().run()}><i className="bi bi-trash"></i></Btn>
        </div>
      )}

      <EditorContent editor={editor} className="tt-content" />
      <input ref={fileRef} type="file" accept="image/*" hidden onChange={enviarImagem} />
    </div>
  );
}
